export default __webpack_public_path__ + "static/media/phone_1.e28d2f49.svg";